import styled from "styled-components";
import Checkbox from "../checkbox/Checkbox";
export const SELECTION_CELL_WIDTH = "32px";
const SELECTION_CELL_HEIGHT = "18px"; // checkboxSize + checkboxBorder
export const StyledTableCellSelection = styled.div.withConfig({ displayName: "StyledTableCellSelection_APC-7281-productShell", componentId: "sc-1xt0su1" })({
    height: SELECTION_CELL_HEIGHT,
    width: SELECTION_CELL_HEIGHT,
});
export const StyledCheckbox = styled(Checkbox).withConfig({ displayName: "StyledCheckbox_APC-7281-productShell", componentId: "sc-cryfri" })({
    margin: 0,
});
//# sourceMappingURL=TableSelectionColumn.style.js.map